import * as React from 'react';

import { ButtonType, ButtonWidget, DialogType } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';
import { ReactModalOptions, ReactModalServiceDialogProps } from '../../ts/services/ReactModalService';
import { UploadWorkbookStyles } from '../styles/UploadWorkbookStyles';

export interface OverwriteConfirmDialogProps extends ReactModalServiceDialogProps {
  openUploadWorkbookDialog: () => void;
  submitWorkbookUpload: () => void;
  workbookName: string;
}
/**
 * Options used for ReactModalService
 */
export function ConfirmOverwriteDialogOpts(props: OverwriteConfirmDialogProps): ReactModalOptions {
  return {
    type: DialogType.NormalWithTitleBar,
    dialogContent: <OverwriteConfirmDialog openUploadWorkbookDialog={props.openUploadWorkbookDialog} submitWorkbookUpload={props.submitWorkbookUpload} workbookName={props.workbookName} close={null}/>,
    title: Messages.contentUpload_overwriteWorkbook(),
    showCloseButton: false,
    dialogWidth: 400,
    shouldNotCloseGlass: true,
    testId: 'upload-workbook-overwrite-confirmation'
  };
}
export class OverwriteConfirmDialog extends React.PureComponent<OverwriteConfirmDialogProps> {

  private handleSubmit = (): void =>  {
    this.props.submitWorkbookUpload();
    this.props.close();
  }

  private handleCancel = (): void =>  {
    this.props.openUploadWorkbookDialog();
    this.props.close();
  }

  render() {
    return (
    <div>
        {Messages.contentUpload_confirmOverwriteWarning({WORKBOOK_NAME:this.props.workbookName})}

        <footer className={UploadWorkbookStyles.footer}>
          <ButtonWidget
            buttonType={ButtonType.Outline}
            testId={'confirm-overwrite-dialog-cancel'}
            children={Messages.cancel()}
            handleClick={this.handleCancel}
          />
          <ButtonWidget
            buttonType={ButtonType.Primary}
            testId={'confirm-overwrite-dialog-submit'}
            children={Messages.contentUpload_overwrite()}
            handleClick={this.handleSubmit}
          />
        </footer>
      </div>
    );
  }
}
